import React, { memo, useEffect, useRef, useState, useCallback } from "react";
import { PlayBackContext } from "../../../../contexts";
import { convertToSeconds, formatDB } from "../../../../utils";
import { Player as RcDPlayer } from "rc-dplayer";
import axiosClient from "../../../../services/axiosClient";
import classNames from "classnames/bind";
import styles from "./VideoPlayer.module.css";
import { Spin } from "antd";
import { useRtspToHls } from "../../../../hooks/useRtspToHls";

const cx = classNames.bind(styles);
const VideoPlayer = ({ item, playing, rerender }) => {
  const { hour, speedPB, timeStart } = React.useContext(PlayBackContext)
  const [path, setPath] = useState('')
  const [data, setData] = useState({})
  const [isChange, setIsChange] = useState(true)
  const [dplay, setDplay] = useState()
  const ref = React.useRef();
  const refWrapperVideo = useRef(null);
  const [loading, setLoading] = useState(true);
  const timeoutRef = useRef(null); // Ref để lưu timeout ID, tránh memory leak

  const [playlist, setRtsp] = useRtspToHls();
  console.log('==========item===========', item);
  React.useEffect(() => {
    if (item?.time_start, item.url === path && dplay && convertToSeconds(hour) < convertToSeconds(item.time_end)) {
      dplay.seek(convertToSeconds(hour) - convertToSeconds(item?.time_start))
    }
  }, [dplay, hour, path])
  React.useEffect(() => {
    console.log('[DEBUG] useEffect - item changed:', {
      code: item?.code,
      recorder_code: item?.recorder_code,
      path: item?.path,
      url: item?.url
    });

    if (item?.recorder_code !== 'OTHER') {
      console.log('[DEBUG] useEffect - Setting RTSP path:', item?.path);
      setRtsp(item?.path);
      console.log('[DEBUG] useEffect - setRtsp() called, hook will process RTSP');
    } else {
      console.log('[DEBUG] useEffect - Setting direct URL path:', item?.url);
      setPath(item?.url);
    }
    setData(item);
    setIsChange(!isChange);
  }, [item])
  const handleNext = useCallback(async () => {
    console.log('==========Handle Next - Video Ended===========');
    console.log('[DEBUG] Current data:', {
      code: data.code,
      time_next: data.time_next,
      recorder_code: data.recorder_code,
      current_path: data.path,
      current_url: data.url
    });
    console.log('[DEBUG] Request params:', {
      camera_code: data.code,
      day: formatDB(timeStart),
      time_line: data.time_next
    });

    try {
      const res = await axiosClient.get(
        `/camPlayback/get-list-path-timeline/`,
        {
          params: {
            list_camera_code: JSON.stringify({
              data: [{
                camera_code: data.code
              }]
            }),
            day: formatDB(timeStart),
            time_line: data.time_next,
          },
        }
      );
      console.log('[DEBUG] API Response:', res);
      console.log('[DEBUG] Raw time_line from API:', res.time_line);

      const time_line = res.time_line.map(item => {
        return {
          url: `${process.env.REACT_APP_BASE_URL}${item?.path.is_stream ? 'livestream' : 'playback'}/${item.next_path?.PATH}`,
          isOption: false,
          name_cam: item?.name_cam,
          status: item.path !== "no-path" ? item.status : "no-video",
          code: item.camera_code,
          time_start: item.path?.TIME_START?.split(' ')[1],
          time_end: item.path?.TIME_END?.split(' ')[1],
          st: item.status,
          next_url: `${process.env.REACT_APP_BASE_URL}${item?.path.is_stream ? 'livestream' : 'playback'}/${item?.next_path?.PATH}`,
          time_next: item.next_path?.TIME_START ? item.next_path?.TIME_START.split(' ')[1] : "No-video",
          recorder_code: item?.recorder_code,
          path: item.next_path?.PATH
        };
      });
      console.log('==========Time Line Next (Processed)==========');
      console.log('[DEBUG] Processed time_line:', time_line);

      if (time_line.length > 0) {
        const nextVideo = time_line[0];
        console.log('[DEBUG] Next video data:', {
          code: nextVideo.code,
          recorder_code: nextVideo.recorder_code,
          path: nextVideo.path,
          url: nextVideo.url,
          time_start: nextVideo.time_start,
          time_end: nextVideo.time_end
        });

        setData(nextVideo);
        setIsChange(false);

        if (nextVideo?.recorder_code !== "OTHER") {
          console.log('[DEBUG] Setting RTSP path for conversion:', nextVideo.path);
          console.log('[DEBUG] Calling setRtsp() with path:', nextVideo.path);
          setRtsp(nextVideo.path);
          console.log('[DEBUG] setRtsp() called - hook will receive new RTSP path');
        } else {
          console.log('[DEBUG] Setting direct URL path (OTHER recorder):', nextVideo.url);
          setPath(nextVideo.url);
          console.log('[DEBUG] setPath() called with URL:', nextVideo.url);
        }
      } else {
        console.log('[DEBUG] No next video found in time_line');
      }
    }
    catch (e) {
      console.error('[DEBUG] Error in handleNext:', e);
      console.error('[DEBUG] Error details:', {
        message: e.message,
        response: e.response,
        stack: e.stack
      });
    }
  }, [data, timeStart, setRtsp, setPath]);

  // useEffect để tự động gọi handleNext khi hết thời gian cho recorder_code !== "OTHER"
  useEffect(() => {
    // Cleanup timeout cũ trước khi set timeout mới
    if (timeoutRef.current) {
      console.log('[DEBUG] Clearing previous timeout to avoid memory leak');
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    // Chỉ xử lý khi recorder_code !== "OTHER" và có đủ thông tin time_start, time_end
    if (data?.recorder_code && data.recorder_code.includes("HIK") && data?.time_start && data?.time_end) {
      const timeStartSeconds = convertToSeconds(data.time_start);
      const timeEndSeconds = convertToSeconds(data.time_end);
      const duration = timeEndSeconds - timeStartSeconds; // Thời gian video (giây)

      console.log('[DEBUG] Auto-next timer setup:', {
        recorder_code: data.recorder_code,
        time_start: data.time_start,
        time_end: data.time_end,
        duration_seconds: duration,
        duration_formatted: `${Math.floor(duration / 60)}:${duration % 60}`
      });

      if (duration > 0) {
        // Set timeout để gọi handleNext sau khi hết thời gian
        timeoutRef.current = setTimeout(() => {
          console.log('[DEBUG] Auto-next timer triggered - calling handleNext');
          handleNext();
          timeoutRef.current = null;
        }, duration * 1000); // Chuyển từ giây sang milliseconds

        console.log('[DEBUG] Auto-next timer set for', duration, 'seconds');
      } else {
        console.warn('[DEBUG] Invalid duration, skipping auto-next timer');
      }
    } else {
      console.log('[DEBUG] Skipping auto-next timer:', {
        has_recorder_code: !!data?.recorder_code,
        is_OTHER: data?.recorder_code === 'OTHER',
        has_time_start: !!data?.time_start,
        has_time_end: !!data?.time_end
      });
    }

    // Cleanup function: clear timeout khi component unmount hoặc data thay đổi
    return () => {
      if (timeoutRef.current) {
        console.log('[DEBUG] Cleanup: clearing auto-next timeout');
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [data?.recorder_code, data?.time_start, data?.time_end, data?.code, handleNext]); // Chỉ chạy lại khi các giá trị này thay đổi

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 100);
    return () => clearTimeout(timeout);
  }, [window.innerWidth, rerender])


  return (
    <>
      {
        loading ? <></> : (
          <div className={cx('video-wrap')} ref={refWrapperVideo}
            style={refWrapperVideo && refWrapperVideo?.current ? { height: `${refWrapperVideo.current.clientWidth * 9 / 16}px` } : {}}
          >
            <RcDPlayer
              ref={ref}
              src={item?.recorder_code !== 'OTHER' ? playlist : path}
              options={{
                hotkey: false,
                autoplay: true,
                mutex: false,
                screenshot: true,
                playbackSpeed: [1, 2, 4, 8, 16],
              }}
              onLoad={(dp) => {
                setDplay(dp)
              }}
              onEnded={handleNext}
              onError={(event) => {
                console.error("error=>>", event);
              }}
            />

          </div>
        )
      }
    </>

  );
};

export default memo(VideoPlayer);
